function getParentNode(element) {
  if (element.nodeName === "HTML") {
    return element;
  }
  return element.parentNode || element.host;
}
function getStyleComputedProperty(element) {
  if (element.nodeType !== 1) {
    return [];
  }
  const window = element.ownerDocument.defaultView;
  return window.getComputedStyle(element, null);
}
function getScrollParent(element) {
  if (!element) {
    return document.body;
  }
  switch (element.nodeName) {
    case "HTML":
    case "BODY":
      return element.ownerDocument.body;
    case "#document":
      return element.body;
  }
  const { overflow, overflowX, overflowY } = getStyleComputedProperty(element);
  if (/(auto|scroll|overlay)/.test(overflow + overflowY + overflowX)) {
    return element;
  }
  return getScrollParent(getParentNode(element));
}
export {
  getParentNode,
  getScrollParent
};
//# sourceMappingURL=utils.js.map
